export default class ThreadForm {
  public targetableId: number
  public targetableType: string = ''
  public name: string = ''
  public id: number = 0
}
